// Flags enum -> backend
export enum PwaSyncUpdateType {
    None = 0,
    MetadataUpdated = 1,
    FileUpdated = 1 << 1,
    VersionUpdated = 1 << 2
}